import React from 'react';
import { BlockInfoType } from '../../common-types/BlockInfo.type';

import { MultiGameScreenConfiguration } from '../../common-types/ScreensConfigurations.type';
import { WelcomeGameScreen } from './WelcomeGameScreen';

interface Props {
  config: MultiGameScreenConfiguration;
  ctaOnClick?: React.MouseEventHandler<HTMLDivElement>;
  addEditableBlock?: (block: BlockInfoType) => void;
  isEdition?: boolean;
  onBlockEdit?: React.MouseEventHandler<HTMLDivElement>;
  thumbnailUrls: { campId: string, url: string }[];
}

export const MultiGameScreen: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <WelcomeGameScreen {...props} welcomeGameScreenType="multiGame" />
  );
};
